import SectionListProps from '../../../../components/HomePage/components/SectionBrowser/SectionListProps';
import { SectionSlot } from '../../../../components/Toolkit/SectionSlot/SectionSlot';
import MarketplaceIcons from '../../../../components/HomePage/Icons/MarketplaceIcons';
import { getDashIcon } from '../../../../components/HomePage/Icons/DashIcons';
import SectionContainer from '../../../../components/HomePage/components/SectionBrowser/styles/SectionContainer';
import { restoreScrollPosition } from '../../../../helpers/scroll';

function MarketplaceSectionsList({ sections, dashLinks }: SectionListProps) {
  return (
    <SectionContainer data-testid="marketplace-section-list">
      {dashLinks?.map(({ displayName, count, icon, url }, index) => {
        return (
          <li key={index}>
            <a href={url} onClick={() => restoreScrollPosition(url)}>
              <SectionSlot
                icon={getDashIcon(icon)}
                text={displayName}
                quantity={count}
              />
            </a>
          </li>
        );
      })}
      {sections.map((section, index) => {
        return (
          <li key={index}>
            <a
              href={`/${section.name}`}
              onClick={() => restoreScrollPosition(`/${section.name}`)}
            >
              <SectionSlot
                icon={MarketplaceIcons[section.name]}
                text={section.displayName}
              />
            </a>
          </li>
        );
      })}
    </SectionContainer>
  );
}

export { MarketplaceSectionsList };
